import React, { useState, useEffect } from 'react';
import { Trash2 } from 'lucide-react';
import { adminStatsService } from '../../../services/adminStatsService';
import { useSeasonContext } from '../../../context/SeasonContext';

const PowerRankingItemBlock = ({ block, onUpdate, onDelete }) => {
  const [teams, setTeams] = useState([]);
  const { selectedSeason } = useSeasonContext();

  useEffect(() => {
    if (selectedSeason?.id) {
      fetchTeams();
    }
  }, [selectedSeason?.id]);

  const fetchTeams = async () => {
    try {
      const playerList = await adminStatsService.getPlayersForSeason(selectedSeason.id);
      const uniqueTeams = [...new Set(playerList.map(p => p.team).filter(Boolean))].sort();
      setTeams(uniqueTeams);
    } catch (error) {
      console.error('Error fetching teams:', error);
    }
  };

  return (
    <div className="block-item power-ranking-block">
      <div className="block-header">
        <span>Power Ranking</span>
        <button
          type="button"
          className="btn-icon-small delete"
          onClick={() => onDelete(block.id)}
        >
          <Trash2 size={16} />
        </button>
      </div>
      <input
        type="number"
        min="1"
        value={block.rank || ''}
        onChange={(e) => onUpdate(block.id, { rank: parseInt(e.target.value) })}
        placeholder="Rank"
        className="field-input"
      />
      <select
        value={block.team || ''}
        onChange={(e) => onUpdate(block.id, { team: e.target.value })}
        className="field-select"
      >
        <option value="">Select team</option>
        {teams.map((team) => (
          <option key={team} value={team}>
            {team}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PowerRankingItemBlock;
